var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFlexi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#FFCB05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 25.8333L25.8299 20.0035L20.0001 14.1736L18.323 15.8507L21.2778 18.8056H14.0105V21.2014H21.2778L18.323 24.1562L20.0001 25.8333ZM20.0001 35.9757C17.8172 35.9757 15.7541 35.5564 13.8108 34.7179C11.8676 33.8793 10.1705 32.7347 8.71967 31.2839C7.26886 29.833 6.12419 28.136 5.28564 26.1927C4.4471 24.2494 4.02783 22.1863 4.02783 20.0035C4.02783 17.794 4.4471 15.7176 5.28564 13.7743C6.12419 11.831 7.26886 10.1406 8.71967 8.70313C10.1705 7.26563 11.8676 6.1276 13.8108 5.28906C15.7541 4.45052 17.8172 4.03125 20.0001 4.03125C22.2096 4.03125 24.286 4.45052 26.2292 5.28906C28.1725 6.1276 29.8629 7.26563 31.3004 8.70313C32.7379 10.1406 33.8759 11.831 34.7145 13.7743C35.553 15.7176 35.9723 17.794 35.9723 20.0035C35.9723 22.1863 35.553 24.2494 34.7145 26.1927C33.8759 28.136 32.7379 29.833 31.3004 31.2839C29.8629 32.7347 28.1725 33.8793 26.2292 34.7179C24.286 35.5564 22.2096 35.9757 20.0001 35.9757ZM20.0001 33.5799C23.7801 33.5799 26.9879 32.2555 29.6233 29.6068C32.2587 26.958 33.5764 23.7569 33.5764 20.0035C33.5764 16.2234 32.2587 13.0156 29.6233 10.3802C26.9879 7.74479 23.7801 6.42708 20.0001 6.42708C16.2466 6.42708 13.0455 7.74479 10.3968 10.3802C7.74803 13.0156 6.42367 16.2234 6.42367 20.0035C6.42367 23.7569 7.74803 26.958 10.3968 29.6068C13.0455 32.2555 16.2466 33.5799 20.0001 33.5799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFlexi);
export default __webpack_public_path__ + "static/media/arrow-flexi.82c4bfaf4aa7ae0b5792d4c51cc2dd24.svg";
export { ForwardRef as ReactComponent };